import React from 'react';

const Features = () => (
  <div className="min-h-screen w-full overflow-x-hidden bg-gradient-to-br from-[#EFF6FF] via-white to-[#F9FAFB]">
    <section className="w-full max-w-7xl mx-auto py-8 sm:py-12 px-4 sm:px-6 lg:px-8">
      <h2 className="text-2xl sm:text-3xl font-bold mb-6 sm:mb-8 text-blue-700 text-center">Features</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 max-w-4xl mx-auto">
        <div className="bg-white p-4 sm:p-6 rounded-lg shadow-md text-center">
          <h3 className="text-lg sm:text-xl font-semibold mb-2 sm:mb-3 text-gray-800">Personalized AI</h3>
          <p className="text-gray-600 text-sm sm:text-base">Tailored responses and experiences for every user.</p>
        </div>
        <div className="bg-white p-4 sm:p-6 rounded-lg shadow-md text-center">
          <h3 className="text-lg sm:text-xl font-semibold mb-2 sm:mb-3 text-gray-800">Real-time Insights</h3>
          <p className="text-gray-600 text-sm sm:text-base">Instant feedback and analytics to improve engagement.</p>
        </div>
        <div className="bg-white p-4 sm:p-6 rounded-lg shadow-md text-center sm:col-span-2 lg:col-span-1">
          <h3 className="text-lg sm:text-xl font-semibold mb-2 sm:mb-3 text-gray-800">Seamless Integration</h3>
          <p className="text-gray-600 text-sm sm:text-base">Easy to connect with your favorite tools and platforms.</p>
        </div>
      </div>
    </section>
  </div>
);

export default Features; 